import * as c from 'common/constants';

/**
 * Set page settings
 */
export const setSettings = (app, settings) => ({
  type: c.SET_SETTINGS,
  app,
  settings,
});

export default setSettings;



// WEBPACK FOOTER //
// ./src/common/actions/setSettings.js